var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('ul',_vm._l((_vm.nav),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.path,"tag":"li"}},[_c('img',{attrs:{"src":item.src,"alt":""}}),_c('p',[_vm._v(_vm._s(item.name))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }